export default __webpack_public_path__ + "static/media/volume_up_black_24dp.57da1130.svg";